import { html, attr, TNode, Value, Ensure, NillifyValue } from '@tempots/dom'
import { Icon } from '@tempots/beatui'

export interface EmptyStateOptions {
  iconName: Value<string>
  title: Value<string>
  description?: Value<string>
  action?: TNode
}

export function EmptyState({
  iconName,
  title,
  description,
  action,
}: EmptyStateOptions) {
  return html.div(
    attr.class('text-center py-12'),
    html.div(
      attr.class(
        'mx-auto w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4'
      ),
      Icon({ icon: iconName }, attr.class('w-8 h-8 text-gray-400'))
    ),
    html.h3(attr.class('text-lg font-medium text-gray-900 mb-2'), title),
    Ensure(description as NillifyValue<string>, (desc) =>
      html.p(attr.class('text-gray-500 mb-4'), desc)
    ),
    action ?? null
  )
}
